import React, { useState } from 'react';
import fetchConfig from '../../fetchConfig';
import FileIcon from '../UI/icons/FileIcon.jsx';
import './FileDownloadOrLinkCard.less';

export default function FileDownloadOrLinkCard(props) {
  const [loading, setLoading] = useState(false);

  const token = sessionStorage.getItem('kctoken');

  const download = async () => {
    setLoading(true);
    const resp = await fetch(fetchConfig.baseUrl + props.url, {
      method: props.method || 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (resp.ok) {
      if (resp.headers.get('Content-Type') === 'application/octet-stream') {
        const blob = await resp.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = resp.headers.get('fileName')
          ? decodeURIComponent(resp.headers.get('fileName'))
          : props.filename;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          window.URL.revokeObjectURL(link);
        }, 200);
      } else {
        setError('Получен неверный тип данных');
        setShow(true);
      }
    } else {
      const error = resp.headers.get('Content-Type').indexOf('application/json') >= 0 ? (await resp.json()) : {};
      setError(error.error && error.error.message || props.customError || 'Не удалось загрузить файл');
      setShow(true);
    }
    setLoading(false);
  };

  return (
    <>
      {' '}
      { props.type === 'file' && (
      <div
        className="card-container"
        style={{ textDecoration: 'none' }}
        onClick={!loading ? download : null}
      >
        <FileIcon mimetype={props.contentType} />
        <span className="title">{props.filename}</span>
      </div>
      )}
      { props.type === 'link'
                && <a className="link" target="_blank" href={props.link} rel="noreferrer">{props.title}</a>}
    </>
  );
}
